export default "__VITE_ASSET__CgxZ5i3z__"